export enum TabPathEnum {
  SHOP_INFO = 'shop-management',
  CATEGORY = 'product-categories',
  PRODUCT = 'products/new',
  SHOP_BUILDER = 'shop-builder',
}
